import type { CarouselImage } from '@/app/[locale]/product/_types/carouselTypes';

const CONTROL_INDICES: number[] = [0, 1, 2, 3];
const VARIANT_ONE_INDICES: number[] = [2, 3, 0, 1];
const VARIANT_TWO_INDICES: number[] = [3, 2, 1, 0];

interface SortedImages {
  readonly images: CarouselImage[];
  readonly indices: number[];
}

const sortImagesForAbTest = (
  images: CarouselImage[],
  variant: number | undefined,
  isOuraRing4Wizard: boolean,
): SortedImages => {
  if (!isOuraRing4Wizard) return { images, indices: CONTROL_INDICES };

  const clonedImages: CarouselImage[] = [];

  let indices = CONTROL_INDICES;
  switch (true) {
    case variant === 1:
      indices = VARIANT_ONE_INDICES;
      break;
    case variant === 2:
      indices = VARIANT_TWO_INDICES;
      break;
  }

  indices.forEach((index) => {
    const image = images[index];
    if (image) {
      clonedImages.push(image);
    }
  });

  return { images: clonedImages.length ? clonedImages : images, indices };
};

export default sortImagesForAbTest;
